module.exports = __webpack_public_path__ + "submenu_index_0.95104d72.png";